import { render, staticRenderFns } from "./RequestQuotation.vue?vue&type=template&id=8a770e26&"
import script from "./RequestQuotation.vue?vue&type=script&lang=js&"
export * from "./RequestQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports